<template>
  <loginHome>
    <div slot="content" class="login-info">
      <div class="login-type">
        <span :class="{'active':loginType===1}" @click="loginTab(1)">帐号登录</span>
        <span :class="{'active':loginType===2}" @click="loginTab(2)">快捷登录</span>
      </div>
      <div v-show="loginType===1">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="请输入手机号" class="login-input">
              <i slot="prefix" class="iconfont icondenglu icon1" style="font-size: 20px"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="ruleForm.password" type="password" placeholder="请输入密码" class="login-input">
              <i slot="prefix" class="iconfont iconicon2 icon1"></i>
              <div slot="suffix" class="set-pass"><a href="/setpass">忘记密码</a></div>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" class="btnLogin" @click="loginType1">立即登录</el-button>
      </div>
      <div v-show="loginType===2">
        <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2">
          <el-form-item prop="tel">
            <el-input v-model="ruleForm2.tel" placeholder="请输入手机号" class="login-input">
              <i slot="prefix" class="iconfont icondenglu icon1"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input v-model="ruleForm2.code" type="text" placeholder="请输入验证码" class="login-input">
              <i slot="prefix" class="iconfont iconshouji1 icon1" style="font-size: 24px!important;"></i>
              <div slot="suffix" style="color:#fff;" class="set-pass" @click="sendCode">{{ codeText }} <span
                v-if="typeof codeText === 'number'">秒后重新发送</span></div>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" class="btnLogin" @click="loginType2">立即登录</el-button>
      </div>
      <div class="login-icons">
        <div class="login-icon-t">
          <i class="left"></i>
          <span>使用其他方式登录</span>
          <i class="right"></i>
        </div>
        <div class="login-img">
          <a
            href="https://open.weixin.qq.com/connect/qrconnect?appid=wxb8f637f517b861b3&redirect_uri=http://zsgl.emof.cn/login&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
            class="login-icon-wx">
            <i class="iconfont iconicon1"></i>

          </a>
          <p class="flex justify-center">微信登录</p>
        </div>

      </div>
      <!--      <div class="no-hao">-->
      <!--        我还没有帐号，<a href="/register">我要注册</a>-->
      <!--      </div>-->
    </div>
  </loginHome>
</template>

<script>
import loginHome from './components/box'

export default {
  name: "login",
  data() {
    return {
      code: '',
      loginType: 1,     //  1:帐号登录   2:快捷登录
      ruleForm: {
        phone: '',  //  手机号
        password: '',   //  密码
      },
      ruleForm2: {
        tel: '',  //  手机号
        code: ''       //  验证码
      },
      rules: {
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {min: 11, max: 11, message: '请输入正确的手机号', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'}
        ]
      },
      rules2: {
        tel: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {min: 11, max: 11, message: '请输入正确的手机号', trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {min: 6, max: 6, message: '请输入正确的验证码', trigger: 'blur'}
        ]
      },
      codeText: '获取验证码', // 验证码文字
      id: null, // 计时器id
      timeId: null, // 一次性计时器id
    }
  },
  created() {
    this.code = this.$route.query.code
    console.log(this.code)

    if (this.code) {
      this.weixinLogin()
    }
  },
  methods: {
    loginTab(num) {
      this.loginType = num
    },
    // 微信登录
    weixinLogin() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$api.apiContent.wxlogin({
        code: this.code,
      }).then(res => {
        loading.close();
        this.$store.state.user = res.data
        this.$store.state.userMid = res.data.mid
        this.$store.state.userName = res.data.mnickname
        this.$store.state.userMthumb = res.data.mthumb
        this.$store.state.userRoleid = res.data.roleid
        this.$store.state.allToken = res.data.emofUserTokenSafer
        this.$router.push({
          path: '/home'
        })
      }).catch(res => {
        loading.close();
        this.$message.error(res.msg);
        if (Number(res.status) === 201) {
          this.$router.push({
            path: '/bindPhone',
            query: {
              unid: res.data,
            }
          })
        }
      })
    },
    //  帐号登录
    loginType1() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '登录中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          this.$api.apiContent.login({
            user_name: this.ruleForm.phone,
            password: this.ruleForm.password     //  this.$md5(this.ruleForm.password)
          }).then(res => {
            loading.close();
            this.$store.state.userMid = res.data.mid
            this.$store.state.userName = res.data.mnickname
            this.$store.state.userMthumb = res.data.mthumb
            this.$store.state.userRoleid = res.data.roleid
            this.$store.state.allToken = res.data.emofUserTokenSafer
            this.$router.push('/home')
          }).catch(e => {
            loading.close();
            this.$message.error(e.msg)
          })
        }
      })
    },
    //  快捷登录
    loginType2() {
      this.$refs['ruleForm2'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '登录中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          this.$api.apiContent.login2({
            phone: this.ruleForm2.tel,
            code: this.ruleForm2.code
          }).then(res => {
            loading.close();
            this.$store.state.userMid = res.data.mid
            this.$store.state.userName = res.data.mnickname
            this.$store.state.userMthumb = res.data.mthumb
            this.$store.state.userRoleid = res.data.roleid
            this.$store.state.allToken = res.data.emofUserTokenSafer
            this.$router.push('/home')
          }).catch(e => {
            loading.close();
            this.$message.error(e.msg)
          })
        }
      })
    },
    //  获取验证码
    sendCode() {
      this.$refs.ruleForm2.validateField('tel', (valid) => {
        if (!valid) {
          // 发送ajax
          if (this.codeText === '获取验证码' || this.codeText === '重新发送') {
            this.codeText = 60
            this.id = setInterval(() => {
              if (this.codeText === 0) {
                this.codeText = '重新发送'
                return
              }
              if (typeof this.codeText === 'number') {
                this.codeText--
              }
            }, 1000)
            this.$api.apiContent.getCode({
              phone: this.ruleForm2.tel,
            }).then().catch(e => {
              this.$message.error(e.msg)
              this.codeText = '重新发送'
              clearInterval(this.id)
            })
          }
        }
      })
    }
  },
  components: {
    loginHome
  }
}
</script>

<style scoped lang="scss">


.login-info {
  display: flex;
  flex-direction: column;
  width: 400px;
  height: 560px;
  background-color: #0a2240;
  border-radius: 10px;
  position: relative;
  padding: 45px;
  //margin-right: 150px;
  z-index: 1;

  &:after {
    position: absolute;
    width: 561px;
    height: 357px;
    background: rgba(10, 34, 64, .1);
    border-radius: 10px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    content: '';
    z-index: -1;
  }

  &:before {
    position: absolute;
    width: 489px;
    height: 450px;
    margin: 0 auto;
    background: rgba(10, 34, 64, .3);
    border-radius: 10px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    content: '';
    z-index: -1;
  }
}


.login-type {
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: relative;
  margin-bottom: 20px;
  border-bottom: 1px solid #ffffff44;

  &:before {
    position: absolute;
    top: 15px;
    left: 50%;
    content: '';
    width: 2px;
    height: 20px;
    background: #ffffff44;
  }

  span {
    display: block;
    line-height: 50px;
    font-size: 18px;
    cursor: pointer;
    color: #ffffff44;
    position: relative;

    &.active {
      color: #fff;

      &:before {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 0);
        content: '';
        width: 80px;
        height: 2px;
        background: #fff;
      }
    }
  }
}

.set-pass {

  //background: #fff;
  width: 100px;
  height: 38px;
  margin-top: 7px;
  cursor: pointer;
  font-size: 12px;
  color: #fff;

  a {
    color: #fff;
  }
}

.btnLogin {
  width: 100%;
  height: 48px;
  background-image: linear-gradient(
      37deg, #ffb400, #fc7802), linear-gradient(#0a2240, #0a2240);
  background-blend-mode: normal, normal;
  color: #ffffff;
  margin-bottom: 20px;
  font-size: 18px;
  border-radius: 5px;
}

.login-icons {
  height: 85px;
  margin-top: 10px;


  .login-icon-t {
    font-size: 12px;
    color: #999;
    height: 36px;
    text-align: center;
    line-height: 36px;
    margin-bottom: 40px;

    .left {
      width: 104px;
      border-bottom: 1px solid #ffffff44;
      float: left;
      margin-top: 18px;
    }

    .right {
      width: 104px;
      border-bottom: 1px solid #ffffff44;
      float: right;
      margin-top: 18px;
    }
  }

  .login-img {
    width: 80px;
    margin: 0 auto;
    text-align: center;

    a.login-icon-wx {
      display: inline-block;
      width: 45px;
      height: 45px;
      background: #fff;
      border-radius: 100%;
      text-align: center;
      line-height: 45px;

      i {
        font-size: 30px;
        color: #0a2240;
      }

    }
    p{
      color: #fff;
    margin-top: 20px;
    }
  }
}

.no-hao {
  line-height: 28px;
  color: #444;
  font-size: 12px;
  text-align: right;

  a {
    color: #236fa5;
  }
}
</style>